
<main class="reference_form-main">
    <div class="main_container">
      <form [formGroup]="seismicdamagelistForm">
      <div class="">
        <h3 class="form_name">SeismicDamageList</h3>
         
          <div class="input">
            <label for=""> Item Name</label>
            <input type="text" class="default_input reference-form" formControlName="ItemName" />
          </div>
  
          <div class="input">
            <label for=""> Opt Approved Rate</label>
            <input type="text" class="default_input reference-form" formControlName="OTPApprovedRate" />
          </div>
  
          <div class="input">
            <label for=""> Company Approved Date</label>
            <input type="text" class="default_input reference-form" formControlName="CompanyApprovedRate" />
          </div>
          
  
        <div class="btn_holder">
          <button class="default_primary-button" (click)="addNew(seismicdamagelistForm.value)">Add</button>
          <button class="default_secondary-btn ml-2" (click)="onClearForm()">Reset</button>
  
        </div>
  
      </div>
    </form>
      <div class="display_table">
        <div class="search_container">
          <input type="text" class="default_input search"
          placeholder="Search for SeismicDamageList"
          [formControl]="control"
          [appAutocomplete]="autocomplete"
          />
          <em class="ti-search"></em> 
  
          <app-autocomplete #autocomplete="appAutocomplete">
            <ng-template appAutocompleteContent>
              <ng-container
                *ngIf="(seismicdamagelists | filterReference: control.value) as result"
              >
                <app-option
                  (click)="selectSeismicDamageList(option.id)"
                  *ngFor="let option of result"
                  [value]="option.ItemName"
                >
                  {{ option.ItemName }}
                </app-option>
                <app-option class="no-result" *ngIf="!result.length"
                  >No result...</app-option
                >
              </ng-container>
            </ng-template>
          </app-autocomplete>
        </div>
  
        <div class="head" >
          <span class="item">S/N</span>
          <span class="item">Item Name</span>
          <span class="item">Opt Approved Rate</span>
          <span class="item"> Company Approved Rate </span>
          <span class="item">Action</span>
  
        </div>
  
      <div class="scroll">
  
      </div>
      <div class="body_content" >
        <div class="the_body"
        *ngFor="let seismicdamagelist of seismicdamagelistFormArray.get('SeismicDamageLists')['controls']; index as i"
        (click)="onEdit(i, seismicdamagelist.value)" style="cursor: pointer;"
        matTooltip="Click to edit"
          aria-label="Button that displays a tooltip when focused or hovered over"
        >
          <span class="content">{{i + 1}}</span>
          <span class="content">{{seismicdamagelist.value.ItemName}}</span>
          <span class="content">{{seismicdamagelist.value.OTPApprovedRate}}</span>
          <span class="content">{{seismicdamagelist.value.CompanyApprovedRate}}</span>
          <span class="content" (click)="$event.stopImmediatePropagation()">
            <button
            class="delete_icon trash"
  
            (click)="deleteSeismicDamageList(i, seismicdamagelist.value)">
            <em class="ti-trash"> </em> </button>
          </span>
  
        </div>
        </div>
        <div class="btn_holder">
          <button class="default_primary-button" (click)="onSubmit(seismicdamagelistFormArray.value)">Submit</button>
        </div>
      </div>
    </div>
  </main>
  
  <div class="box green_box"></div>
  <div class="box pink_box"></div>
  